/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {RenderElement} from "App/model/elements/element";
import Description from "App/model/description";
import GeometryEntityElement from "App/model/elements/geometry_entity_element";
import ExternalModel from "App/model/elements/external_model";
import GlobeModel from "App/model/elements/globe_model";

export enum EEmbededElementTypes {
    ROOF = "Roof",
    WALL = "Wall",
    FLOOR = "Floor",
    GEOMETRYENTITY = "GeometryEntity", // this is just abstract container for the concrete entities
    POIENTITY = "PoiEntity",
    TOWNENTITY = "TownEntity",
    MOUNTAINENTITY = "MountainEntity",
    WATERENTITY = "WaterEntity",
    ANIMATIONENTITY = "AnimationEntity",
    MEASUREPOINTENTITY = "MeasurePointEntity",
    TEXT = "Text",
    POINTCLOUD = "PointCloud",
    MESH = "Mesh",
    LINE = "Line",
    CURVE = "Curve",
    POINT = "Point",
    IVCOMPOSITION = "IvComposition",
    SKYBOX = "Skybox",
    SKYDOME = "SkyDome",
    GROUNDPLANE = "GroundPlane",
    PLANE = "Plane",
    TUBE = "Tube",
    GRASS = "Grass",
    HEIGHTMAPTILE = "HeightMapTile",
    GEOPOINT = "GeoPoint",
    GEOPATH = "GeoPath",
    SHADOWVOLUME = "ShadowVolume",
    PARTICLES = "Particles",
    CHUNKLODNODE = "ChunkLODNode",
    TEXTUREDQUAD = "TexturedQuad",
    SIGHTPOINT = "SightPoint",
    BOUNDINGBOX = "BoundingBox",
    INSTRUMENT = "Instrument", // for bim bam
    TOTALSTATION = "TotalStation", // for bim bam
    UNKNOWN = "Unknown"
}

export class Factory {

    private static UID: number = 1;
    private static registeredElements: any = {};

    public static register(aElementType: string, aRegisteredClass: any) {
        Factory.registeredElements[aElementType] = aRegisteredClass;
    }

    public static create(aTypeName: string, aModelDescription: Description) {
        Factory.UID++;

        let registeredClass = Factory.registeredElements[aTypeName];
        if (registeredClass === undefined) {
            // register not registered type and use the element class by default for them
            registeredClass = RenderElement;
            Factory.register(aTypeName, registeredClass);
        }

        return registeredClass.create(aModelDescription, Factory.UID);
    }
}

Factory.register("Roof", RenderElement);
Factory.register("Wall", RenderElement);
Factory.register("Floor", RenderElement);
Factory.register("Poi", GeometryEntityElement); // Poi is deprecated, converted to PoiEntity
Factory.register("GeometryEntity", GeometryEntityElement);
Factory.register("PoiEntity", RenderElement);
Factory.register("TownEntity", RenderElement);
Factory.register("MountainEntity", RenderElement);
Factory.register("WaterEntity", RenderElement);
Factory.register("AnimationEntity", RenderElement);
Factory.register("MeasurePointEntity", RenderElement);
Factory.register("Text", RenderElement);
Factory.register("PointCloud", RenderElement);
Factory.register("Mesh", RenderElement);
Factory.register("Curve", RenderElement);
Factory.register("Point", RenderElement);
Factory.register("IvComposition", RenderElement);
Factory.register("Skybox", RenderElement);
Factory.register("HeightMapTile", RenderElement);
Factory.register("ShadowVolume", RenderElement);
Factory.register("SnowParticles", RenderElement);
Factory.register("Unknown", RenderElement);
Factory.register("ExternalModel", ExternalModel);
Factory.register("GlobeModel", GlobeModel);
// Factory.register("SightPoint", SightPoint);

// the not known types will be loaded and parsed as general Element
